import { IMAGE_URL } from "@/data/constants";

const apiUrl = process.env.NEXT_PUBLIC_API_URL ?? "";
const normalizedApiBase = apiUrl.replace(/\/api\/?$/, "");

const graphqlUrl =
  process.env.NEXT_PUBLIC_API_GRAPHQL_URL ??
  (normalizedApiBase ? `${normalizedApiBase}/api/graphql` : "");

const envConfig = {
  imgStoreUrl: (process.env.NEXT_PUBLIC_IMG_STORE_URL || IMAGE_URL) as string,

  // Base URL for REST API (without trailing /api)
  publicServerUrl: normalizedApiBase,

  // Full GraphQL endpoint URL
  publicQraphqlUrl: graphqlUrl,

  // Frontend client URL (taken only from env)
  clientUrl: process.env.NEXT_PUBLIC_CLIENT_URL ?? "",

  nodeEnv: process.env.NEXT_PUBLIC_NODE_ENV ?? "development",

  enableAds: process.env.NEXT_PUBLIC_ENABLE_ADS ?? "false",
  googleAdId: process.env.NEXT_PUBLIC_GOOGLE_AD_CLIENT_ID ?? "",

  previewSecretKey: process.env.NEXT_PUBLIC_PREVIEW_SECRET ?? "",
};

export default envConfig;
